import React, { useState, useEffect } from "react";
import { setTitle } from "../helpers/MetaTag";
import Input from "../components/form/Input";
import Button from "../components/form/Button";
import toastr from "toastr";
import { useNavigate } from "react-router";
import Searching from '../components/Searching';
import NoDataFound from '../components/NoDataFound';

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { MAIN_LOGO } from "../constant/Constant";
import Image from "../components/elements/Image";

const PasswordCreate = () => {
    setTitle("Succession Planning Software for your Business with Succession Now | Create Password")
    const { t } = useTranslation();
    const navigate = useNavigate();
    const hashNumber = new URLSearchParams(window.location.search).get("hash");
    const [loading, setLoading] = useState(true);
    const [dispalayMessage,setDisplayMessage] =  useState('');
    const [isCheck,setIsCheck] = useState(1);
    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');
    const [isChangePassword,setIsChangePassword] = useState(false);

    useEffect(() => {
        const verifyFn = async () => {
            setLoading(true);
            try {
            const userData = await postData("verify-hash", {
                hash_number : hashNumber,
            });
            if (userData.status && userData.status === 200) {
                setLoading(false);
                setIsCheck(2);
            } else {
                setLoading(false);
                setDisplayMessage(userData.message)
            }
            } catch (error) {
                setLoading(false);
                setDisplayMessage(error.message)
            }
        };
        verifyFn();
    }, [hashNumber]);

    const onChangePassword = async (e) => {
        e.preventDefault();
        setIsChangePassword(true);
        try {
          const userData = await postData("create-password", {
            hash_number : hashNumber,
            password: password,
            confirm_password : confirmPassword,
          });
          if (userData.status && userData.status === 200) {
            setIsChangePassword(false);
            toastr.success(userData.message);
            return navigate("/signin");
          } else {
            toastr.error(userData.message);
            setIsChangePassword(false);
          }
        } catch (error) {
          toastr.error(error.message);
          setIsChangePassword(false);
        }
      };


    return(
        <div className="w-full min-h-screen flex justify-center items-center bg-slate-100 py-10">
            <div className="w-full max-w-sm">
              <Link to={"/"}>
                        <div className="h-14 w-full flex justify-center object-contain mb-5">
                          <Image
                            src={MAIN_LOGO}
                            alt={""}
                            width={"100%"}
                            height={"100%"}
                            classes={"object-contain object-center"}
                          />
                        </div>
                      </Link>
              <div className="w-full bg-white rounded shadow-md py-8 px-6">
                {
                  (isCheck && isCheck === 1)?
                  <div className="divide-y divide-slate-200 space-y-4">
                    {
                        loading?<Searching label={'Loading...'}/>:<NoDataFound label={dispalayMessage}/>
                    }
                    <div className="flex gap-1 item-center justify-center text-slate-400 text-sm pt-4">
                        {t('you_have_been_here_before')}
                        <Link to={"/signin"} className="text-teal-500 font-semibold">{t('signin')}</Link>
                        {t('now')}
                    </div>  
                  </div>:
                  <div className="divide-y divide-slate-200 space-y-4">
                    <div className="relative">
                        <h1 className="text-xl font-semibold text-center text-slate-700">
                        {t('create_a_password')}
                        </h1>
                        <div className="text-sm text-slate-400 text-center font-light">
                        {t('welcome_to_succession_now_please_create_your_password')}
                        </div>
                    </div>
                    <div className="pt-4 space-y-4"> 
                        <div className="relative">
                            <Input
                                label={t('password')}
                                labelClasses={"!text-xs"}
                                inputType={"password"}
                                inputPlaceholder={t('your_password')}
                                inputValue={password}
                                setInput={setPassword}
                                //errorType={''}
                            />
                        </div> 
                        <div className="relative">
                            <Input
                                label={t('confirm_password')}
                                labelClasses={"!text-xs"}
                                inputType={"password"}
                                inputPlaceholder={t('your_password')}
                                inputValue={confirmPassword}
                                setInput={setConfirmPassword}
                                //errorType={''}
                            />
                        </div>             
                        <div className="relative flex justify-center">
                        <Button
                            buttonClasses=""
                            buttonLabelClasses=""
                            buttonType={"button"}
                            buttonIcon={(isChangePassword)?"fa-light fa-spinner fa-spin":"fa-light fa-arrow-right-to-arc"}
                            buttonIconPosition={"left"}
                            buttonLabel={t('save_password')}
                            functions={onChangePassword}
                            buttonHasLink={false}
                            buttonDisabled={isChangePassword}
                        />
                        </div>
                    </div>                    
                </div>
                }
              </div>
            </div>
        </div>
    )
}
export default PasswordCreate;